export const GetBackIcon = () => {
	return (
		<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6.70573 1.12891L2.05509 5.77954C1.63203 6.20261 1.63203 6.88854 2.05509 7.31161L6.70573 11.9622"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	)
}
